import { ApiError } from '@isgportal/shared';
import { QueryClient } from '@tanstack/react-query';

// TanStack Query istemcisi. 401 sonrası refresh rotasyonu API client'ta ele
// alınır; buradaki retry yalnız geçici ağ hataları içindir. Kimlik/yetki (4xx)
// hatalarında retry YAPILMAZ (kullanıcıya anında sonuç).
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.statusCode >= 400 && error.statusCode < 500) {
          return false;
        }
        return failureCount < 2;
      },
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});
